module.exports = __webpack_public_path__ + "static/media/portfolio-img6.3cd14e36.jpg";